<af-main-container class="fill-height"
                   [title]="titleKey | translate"
                   [tabPathToTab]="tabPathToTab">
    <div CustomButtons fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px">
        @if (canEdit && activeDashboard) {
            <ui-kit-svg matRipple
                        [matRippleCentered]="true"
                        [matRippleUnbounded]="true"
                        class="i-24 pointer"
                        name="ic_edit"
                        [matTooltip]="'i18n_af_buttonEdit' | translate"
                        (click)="editDashboard()"/>
        }
        @if (canDelete && activeDashboard) {
            <ui-kit-svg matRipple
                        [matRippleCentered]="true"
                        [matRippleUnbounded]="true"
                        class="i-24 pointer"
                        name="ic_delete"
                        [matTooltip]="'i18n_af_buttonDelete' | translate"
                        (click)="deleteDashboard()"/>
        }
        @if (canCreate) {
            <ui-kit-button buttonType="button"
                           [fitContent]="true"
                           (clickListener)="createDashboard()"
                           [label]="'i18n_af_buttonCreateDashboard' | translate"/>
        }
    </div>

    <div class="dashboard-page w-100">
        <div class="dashboard-tabs-row w-100 mt-16" fxLayout="row" fxLayoutAlign="space-between end">
            <mat-tab-group mat-align-tabs="start" animationDuration="0"
                           class="dashboard-tabs"
                           [(selectedIndex)]="selectedTabIndex"
                           (selectedIndexChange)="handleNavigation($event)">
                @for (dashboard of dashboards; track dashboard.id) {
                    <mat-tab [label]="dashboard.name"/>
                }
            </mat-tab-group>

            @for (dashboard of activeDashboards; track dashboard.id) {
                @if (dashboardFilterFields[dashboard.id].length) {
                    <af-filter class="ml-16 mb-8"
                               [showSearchBar]="false"
                               [filterFields]="dashboardFilterFields[dashboard.id]"
                               [filterEvent]="filterEvents[dashboard.id]"
                               (filterListener)="handleFilterChange(dashboard, $event)"/>
                }
            }
        </div>

        <div class="dashboard-bodies w-100">
            @for (dashboard of mountedDashboards; track dashboard.id) {
                <div class="tab-content"
                     [class.hidden]="dashboard.id !== activeDashboard?.id">
                    @if (visitedDashboardIds.has(dashboard.id)) {
                        <af-superset-dashboard [dashboard]="dashboard"
                                               [supersetDomain]="supersetDomain"
                                               [filterValue]="filterValues[dashboard.id]"/>
                    }
                </div>
            }
        </div>
    </div>
</af-main-container>
